"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_1 = require("react-router");
const URLs_1 = require("../utility/URLs");
const react_bootstrap_1 = require("react-bootstrap");
function CategoryCreator(props) {
    const [name, setname] = react_1.default.useState(null);
    function submit() {
        (0, URLs_1.ApiCallHandler)(() => __awaiter(this, void 0, void 0, function* () { return yield URLs_1.Api.createCategory(name); }), (data) => {
            alert(data.success);
            setredirect(URLs_1.Routes.categoriesIndex);
        }, 'CategoryCreator submit', true);
    }
    const [redirect, setredirect] = react_1.default.useState(null);
    if (redirect)
        return react_1.default.createElement(react_router_1.Redirect, { to: redirect });
    return react_1.default.createElement("div", null,
        react_1.default.createElement("input", { type: 'text', onChange: e => setname(e.target.value) }),
        react_1.default.createElement(react_bootstrap_1.Button, { onClick: submit }, "submit"));
}
exports.default = CategoryCreator;
